import SetPasswordForUserRequestModelBase from '../_generated/modelBases/set-password-for-user-request-model-base';

export default class SetPasswordForUserRequestModel extends SetPasswordForUserRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
